'use strict';

var react = require('react');

const EMPTY_SYMBOL = Symbol("EMPTY");
function createScopedContext({
  rootComponentName,
  displayName,
  providerFactory
}) {
  const Context = react.createContext(
    EMPTY_SYMBOL
  );
  if (process.env.NODE_ENV === "development") {
    Context.displayName = displayName;
  }
  return {
    Provider: providerFactory ? providerFactory(Context.Provider) : Context.Provider,
    Consumer: Context.Consumer,
    displayName,
    useContextValue: () => {
      const context = react.useContext(Context);
      if (context === EMPTY_SYMBOL) {
        throw new Error(
          rootComponentName ? `${displayName}.useContextValue\uB294 ${rootComponentName} \uD558\uC704\uC5D0\uC11C \uC0AC\uC6A9\uD574\uC57C \uD569\uB2C8\uB2E4.` : `${displayName}.useContextValue\uB294 ${displayName}.Provider \uD558\uC704\uC5D0\uC11C \uC0AC\uC6A9\uD574\uC57C \uD569\uB2C8\uB2E4.`
        );
      }
      return context;
    }
  };
}

module.exports = createScopedContext;
//# sourceMappingURL=createScopedContext.cjs.map
